import { copy } from "angular";
import { v4 as uuidv4 } from "uuid";
import { Alert, IAlertState, AlertType } from "./alert";
import {
  Goal,
  IGoalState,
  IImportedGoalState,
  IDraftGoalState,
  IDraftGoalMetricState,
  IImportedGoalMetricState,
  cloneGoal,
  isDraftOrImportedGoalState,
  cloneAsImportedGoal,
} from "./goal";
import { Note, INoteState } from "./note";
import { Heading, IHeadingState } from "./heading";
import { Async, IAsyncState } from "./async";
import { Image, IImageState } from "./image";
import { BasicShape, IBasicShapeState } from "./basic-shape";

export * from "./shape";
export * from "./util";

export type {
  IAsyncState,
  IAlertState,
  AlertType,
  IGoalState,
  IDraftGoalMetricState,
  IImportedGoalMetricState,
  IImportedGoalState,
  IDraftGoalState,
  INoteState,
  IHeadingState,
  IImageState,
};
export { Async, Alert, Goal, Note, Heading, Image, isDraftOrImportedGoalState, cloneAsImportedGoal };

export type IWhiteboardShapeState = IGoalState | INoteState | IHeadingState | IAsyncState | IAlertState | IImageState | IBasicShapeState;

export type WhiteboardShapeStateType = IWhiteboardShapeState["type"];

const customCloneMap = {
  goal: cloneGoal,
  draftGoal: cloneGoal,
};

export const isImportedType = (type: WhiteboardShapeStateType): boolean => type === "goal";

export const cloneShape = (shape: IWhiteboardShapeState): IWhiteboardShapeState => {
  if (shape.type in customCloneMap) {
    return customCloneMap[shape.type](shape);
  }

  const copiedShape = copy(shape);
  copiedShape.id = uuidv4();

  delete copiedShape.bsonId;

  if (copiedShape.type === "note") {
    delete copiedShape.reactions;
  }

  return copiedShape;
};

export const extractOriginalShape = (shape: IAlertState | IAsyncState): IWhiteboardShapeState => {
  return { ...shape.original, position: shape.position, zIndex: shape.zIndex };
};

export const shapes = [Alert, Goal, Note, Heading, Async, Image, BasicShape];
